import { render, staticRenderFns } from "./roadmap.vue?vue&type=template&id=33855385&"
import script from "./roadmap.vue?vue&type=script&lang=js&"
export * from "./roadmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports